import { useRef } from "react";
import PackageRequestList from "./request-expired-date-list";

const PackageRequestMain = (props) => {
  const listRef = useRef(null);

  // handle ui event section

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <PackageRequestList
        ref={listRef}
      />
    </div>
  );
};

export default PackageRequestMain;
